import React from "react";


import "./Merch.css"; // Import the external CSS file

const Merch = () => {
  

  return (
   <>
   <div className="merchandize">
      <div className="merchTitle">
          <p>Contact for pricing and shipping:</p>
          <h2>DODSEGO @ GMAIL.COM</h2>
      </div>
      <div className="merchItem"> 
        <img src="/images/Black_unisex_design_05.png" width="100%" height="100%" alt="Black unisex design 05"/>
      
      </div>
      <div className="merchItem">  
        <img src="/images/Black_unisex_design_16.png" width="100%" height="100%" alt="Black unisex design 16"/>
      
      </div>
    </div>
   </>
  );
};

export default Merch;